export async function fetchWithCsrf<T>(url: string, options: RequestInit = {}): Promise<T> {
  const csrfToken = document.cookie.replace(/(?:(?:^|.*;\s*)csrftoken\s*=\s*([^;]*).*$)|^.*$/, '$1');

  // Ensure headers object exists and merge CSRF token
  const headers = new Headers(options.headers);
  if (csrfToken) {
    headers.set('X-CSRFToken', csrfToken);
  }

  // Ensure Content-Type is set for POST/PUT/PATCH requests
  if (['POST', 'PUT', 'PATCH'].includes(options.method?.toUpperCase() || '')) {
    if (!headers.has('Content-Type')) {
      headers.set('Content-Type', 'application/json');
    }
  }

  return await apiRequest<T>(url, { ...options, headers });
}

async function apiRequest<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
  return fetch(endpoint, {
    credentials: 'include',
    ...options,
  }).then(async (response) => {
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    // 204 No Content (and 205) carry no body — calling .json() throws
    // "Unexpected end of JSON input". Return undefined so callers typed as
    // `<void>` resolve cleanly. Some servers also return 200 with an empty
    // body; guard on Content-Length: 0 too.
    if (response.status === 204 || response.status === 205) {
      return undefined as T;
    }
    if (response.headers.get('content-length') === '0') {
      return undefined as T;
    }
    const text = await response.text();
    return (text ? JSON.parse(text) : undefined) as T;
  });
}
